module.exports = __webpack_public_path__ + "6d5d1f7ebe283c45f01d629d896ff643.png";